<template>
  <div class="cwzIndex">
    <div class="header">
      <div class="top">
        <div class="left"><img src="../../static/logo.png" /></div>
        <div class="middle">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">首页</el-menu-item>
            <!-- <el-menu-item index="2">产品介绍</el-menu-item>
            <el-menu-item index="3">关于我们</el-menu-item> -->
          </el-menu>
        </div>
      </div>
    </div>
    <div class="topPaddingBox"></div>
    <div class="imgBox">
      <swiper :options="swiperOption" class='swiper-box'>
        <swiper-slide v-for="(item, index) in swipers" :key="index">
          <img :src="'../../static/banners/' + item.image" class="swiper-img" style="width: 100%;">
        </swiper-slide>
        <div class="swiper-pagination" v-for="(item, index) in swipers" :key="index" slot="pagination"></div>
      </swiper>
    </div>
    <!-- <div class="noticeBox">
      <div class="titleName"><span>企业头条</span></div>
      <swiper :options="swiperNoticeOption" class='swiper-box'>
        <swiper-slide v-for="(item, index) in swiperMsgs" :key="index">
          <a style="text-decoration: none;" href="javascript:void(0)">{{item.title}}</a>
        </swiper-slide>
      </swiper>
      <div class="more">
        <span>查看全部</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div> -->
    <div class="box1">
      <h2>口诀服务平台</h2>
    </div>
    <div class="box2">
      <div class="item1">
        <div><img src="../../static/images/item1.svg" /></div>
        <div class="padding"><span class="mainTitle">进销存</span></div>
        <div class="content"><span>通过功能一体化、服务SAAS化、应用多终端化，让用户可以一站式、随时随地随手、更快速更准确更有效地处理工作，极大地提升了管理效率</span></div>
        <!-- <div class="more">
          <a href="javascript:void(0)">
            <span>了解详情</span>
            <i class="el-icon-right"></i>
          </a>
        </div> -->
      </div>
      <div class="item2">
        <div><img src="../../static/images/item2.svg" /></div>
        <div class="padding"><span class="mainTitle">ERP</span></div>
        <div class="content"><span>集采购、销售、库存管理和应收、应付款管理为一体，提供订单、采购、销售、退货、库存、往来发票、往来账款、业务员等的管理</span></div>
        <!-- <div class="more">
          <a href="javascript:void(0)">
            <span>了解详情</span>
            <i class="el-icon-right"></i>
          </a>
        </div> -->
      </div>
      <div class="item3">
        <div><img src="../../static/images/item3.svg" /></div>
        <div class="padding"><span class="mainTitle">POS</span></div>
        <div class="content"><span>全方位触达消费者，消费者即渠道，微信营销，消息推送精准，实现线上领券线下消费，完美融合移动互联网，微消息智能推送，实现店铺二次引流提升店铺业绩，零投入品牌宣传</span></div>
        <!-- <div class="more">
          <a href="javascript:void(0)">
            <span>了解详情</span>
            <i class="el-icon-right"></i>
          </a>
        </div> -->
      </div>
    </div>
    <div class="topPaddingBox"></div>
    <div class="productBox">
      <div class="main">
        <div class="left">
          <div :class="tabIndex==0?'item active':'item'" @click.stop="productChange(0)">
            <div class="itemLeft">
              <img v-if="tabIndex==0" src="../assets/1-1.svg" />
              <img v-else src="../assets/1.svg" />
            </div>
            <div class="itemRight">
              <div class="pname"><span>进销存</span></div>
              <div class="pdes"><span>看似简单，实则功能强大</span></div>
            </div>
          </div>
          <div :class="tabIndex==1?'item active':'item'" @click.stop="productChange(1)">
            <div class="itemLeft">
              <img v-if="tabIndex==1" src="../assets/2-1.svg" />
              <img v-else src="../assets/2.svg" />
            </div>
            <div class="itemRight">
              <div class="pname"><span>POS</span></div>
              <div class="pdes"><span>简单易懂，傻瓜式操作</span></div>
            </div>
          </div>
          <div :class="tabIndex==2?'item active':'item'" @click.stop="productChange(2)">
            <div class="itemLeft">
              <img v-if="tabIndex==2" src="../assets/3-1.svg" />
              <img v-else src="../assets/3.svg" />
            </div>
            <div class="itemRight">
              <div class="pname"><span>ERP</span></div>
              <div class="pdes"><span>一站式、快速、准确、效率</span></div>
            </div>
          </div>
          <div :class="tabIndex==3?'item active':'item'" @click.stop="productChange(3)">
            <div class="itemLeft">
              <img v-if="tabIndex==3" src="../assets/4-1.svg" />
              <img v-else src="../assets/4.svg" />
            </div>
            <div class="itemRight">
              <div class="pname"><span>供应链</span></div>
              <div class="pdes"><span>各环节数据无缝衔接</span></div>
            </div>
          </div>
          <div :class="tabIndex==4?'item active':'item'" @click.stop="productChange(4)">
            <div class="itemLeft">
              <img v-if="tabIndex==4" src="../assets/5-1.svg" />
              <img v-else src="../assets/5.svg" />
            </div>
            <div class="itemRight">
              <div class="pname"><span>APP</span></div>
              <div class="pdes"><span>办公移动化，实时掌握数据</span></div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="headTitle"><span>{{productTitle[tabIndex]}}</span></div>
          <div class="subTitle"><span>行业背景</span></div>
          <div class="subContent"><span>我们是，国内领先的技术研发高科技公司。践行“技术研发+人工智能+大数 据”的创新型高科技公司核心战略，基于自行研发团队强大的研发能力，为客户提 供定制化的一站式人工智能名片开发服务，在IT、通讯及电商领域有深厚的积淀</span></div>
          <!-- <div class="subMore">
            <div class="btn">了解详情</div>
          </div> -->
          <!-- <div class="cusDemo">
            <div class="demoTitle"><span>相关客户案例</span></div>
            <div class="imgItem">
              <div class="imgBox">
                <img src="../assets/custom1.png" />
              </div>
              <div class="imgBox">
                <img src="../assets/custom2.png" />
              </div>
              <div class="imgBox">
                <img src="../assets/custom3.png" />
              </div>
              <div class="imgBox">
                <img src="../assets/custom4.jpg" />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="solution">
      <div class="soluTitle"><h2>正在为企业及个人解决</h2></div>
      <div class="soluItemBox">
        <div class="soluItem1">
          <div class="soluAlert1">
            <div class="alertTitle"><span>信息整合</span></div>
            <div class="alertLine"></div>
            <div class="alertContent"><span>文字、图象、语音等信息智能处理</span></div>
          </div>
          <img src="../assets/solu1.png" />
        </div>
        <div class="soluItem1">
          <div class="soluAlert2">
            <div class="alertTitle"><span>优化管理</span></div>
            <div class="alertLine"></div>
            <div class="alertContent"><span>一站式、随时随地随手、更快速更准确更有效</span></div>
          </div>
          <img src="../assets/solu2.jpg" />
        </div>
        <div class="soluItem2">
          <div class="soluAlert1">
            <div class="alertTitle"><span>促进营销</span></div>
            <div class="alertLine"></div>
            <div class="alertContent"><span>提供信息化、电商化、互联网化的整体营销方案</span></div>
          </div>
          <img src="../assets/solu3.png" />
        </div>
        <div class="soluItem2">
          <div class="soluAlert1">
            <div class="alertTitle"><span>提高效益</span></div>
            <div class="alertLine"></div>
            <div class="alertContent"><span>自由构建企业生态圈，提高企业业务效益</span></div>
          </div>
          <img src="../assets/solu4.png" />
        </div>
        <div class="soluItem3">
          <div class="soluAlert1">
            <div class="alertTitle"><span>资源倍增</span></div>
            <div class="alertLine"></div>
            <div class="alertContent"><span>互联互通与资源共享</span></div>
          </div>
          <img src="../assets/solu5.png" />
        </div>
      </div>
    </div>
    <div class="news">
      <div class="newsTitle"><h2>新闻动态</h2></div>
      <div class="newsItemBox">
        <div class="newsItem1">
          <div class="newsImgTxtBox">
            <div class="newsImgBox">
              <img src="../assets/news1.png" />
            </div>
            <div class="newsTxtBox">
              <span>口诀POS竟然如此好用</span>
            </div>
          </div>
        </div>
        <div class="newsItem2">
          <div class="newsImgTxtBox">
            <div class="newsImgBox">
              <img src="../assets/news2.png" />
            </div>
            <div class="newsTxtBox">
              <span>进销存3.0版本优化迭代正式启动</span>
            </div>
          </div>
        </div>
        <div class="newsItem2">
          <div class="newsImgTxtBox">
            <div class="newsImgBox">
              <img src="../assets/news3.png" />
            </div>
            <div class="newsTxtBox">
              <span>及时沟通，我选口诀爱沟通</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="appBox">
      <p><span>让天下没有难做的企业</span></p>
      <!-- <div class="appBtnBox"><span>申请使用</span></div> -->
    </div>
    <div class="cwzfooter">
      <div class="footItem1">
        <img src="../../static/logoWrite.png" />
        <div class="website"><span>www.bnansoft.net</span></div>
        <div class="addr"><span>浙江省杭州市临平区万米中心10楼</span></div>
        <div class="addr"><span>联系我们：18667115657</span></div>
      </div>
      <!-- <div class="footItem2">
        <div class="ksTitle"><span>快速入口</span></div>
        <div class="ksLink"><a href="javascript:void(0)">首页</a></div>
        <div class="ksLink"><a href="javascript:void(0)">产品介绍</a></div>
        <div class="ksLink"><a href="javascript:void(0)">产品服务</a></div>
      </div> -->
      <div class="footItem3">
        <div class="ksTitle"><span>&nbsp; &nbsp;</span></div>
        <!-- <div class="ksLink"><a href="javascript:void(0)">帮助中心</a></div>
        <div class="ksLink"><a href="javascript:void(0)">关于我们</a></div> -->
      </div>
      <div class="footItem4">
        <div class="ksTitle"><span>杭州布喃网络科技有限公司</span></div>
        <div class="ksLink"><span>为中小企业提供信息化、电商化、互联网化的整体解决方案，真正做到让天下没有难做的企业！</span></div>
      </div>
      <div class="beian">
        <div>©2020-2025 杭州布喃网络科技有限公司 版权所有</div>
        <div><img src="../../static/images/beian.png" style="width: 20px;" /><a href="https://beian.miit.gov.cn/">浙ICP备2020039372号-3</a></div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'index',
    data() {
      return {
        activeIndex: "1",
        swiperOption: {
          autoplay: 3000,
          pagination: '.swiper-pagination',
          autoplayDisableOnInteraction: false,
          loop: true
        },
        swipers: [{ image: "banner1.jpg" }, { image: "banner2.png" }, { image: "banner3.jpg" }],
        swiperNoticeOption: {
          autoplay: 3000,
          pagination: '.swiper-pagination',
          autoplayDisableOnInteraction: false,
          direction: 'vertical',
          loop: true
        },
        swiperMsgs: [{ title: "马克龙宣布法国将再次封国" }, { title: "韩国前总统李明博终审获刑17年" }, { title: "甘肃载30人大巴坠入农家院" }],
        tabIndex: 0,
        productTitle: ['进销存系统', '门店终端POS系统', 'ERP管理系统', '生产供应商系统', '口诀APP']
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      productChange(idx) {
        this.tabIndex = idx;
      }
    }
  }

</script>

<style lang="less" scoped="scoped">

  .cwzIndex {
    width: 100%;
    margin: 0;
    padding: 0;
    position: relative;
    .header {
      width: 100%;
      height: 60px;
      overflow: hidden;
      position: fixed;
      top: 0;
      left: 0;
      border-bottom: 1px solid #ececec;
      display: flex;
      justify-content:center;
      align-items: center;
      background-color: #FFFFFF;
      z-index: 10;
      .top {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        div {
          box-sizing: border-box;
        }
        .left {
          height: 36px;
          line-height: 36px;
          padding-left: 80px;
          img {
            height: 36px;
          }
        }
        .middle {
          margin-left: 120px;
        }
      }
    }
    .topPaddingBox {
      width: 100%;
      height: 61px;
    }
    .imgBox {
      width: 100%;
      height: 350px;
      box-sizing: border-box;
      overflow: hidden;
      .swiper-box {
        width: 100%;
        height: 350px;
        padding: 0;
        margin: 0;
      }
    }
    .noticeBox {
      width: 100%;
      height: 50px;
      padding: 0 80px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .titleName {
        width: 150px;
        span {
          font-size: 18px;
          font-weight: bolder;
          color: #409EFF;
        }
      }
      .swiper-box {
        width: calc(100% - 180px);
        height: 50px;
        line-height: 50px;
        padding: 0;
        margin: 0;
        a {
          font-size: 18px;
          color: #333;
        }
      }
      .more {
        width: 100px;
        cursor: pointer;
        text-align: right;
        span {
          font-size: 18px;
        }
      }
    }
    .box1 {
      width: 100%;
      text-align: center;
      margin: 20px 0 50px;
    }
    .box2 {
      width: calc(100% - 160px);
      height: 360px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 80px;
      box-sizing: border-box;
      .item1 {
        width: 30%;
        height: 360px;
        box-sizing: border-box;
        div {
          width: 100%;
          text-align: center;
          box-sizing: border-box;
        }
        .padding {
          padding: 30px 0;
          .mainTitle {
            font-size: 24px;
            color: #333;
          }
        }
        .content {
          height: 80px;
          color: #999;
        }
        .more {
          color: #999;
          font-size: 18px;
          padding: 24px 0;
          display: flex;
          justify-content:center;
          align-items: center;
          a {
            font-size: 18px;
            color: #999;
          }
          i {
            margin-left: 5px;
            font-size: 18px;
          }
        }
      }
      .item2 {
        width: 30%;
        height: 360px;
        margin-left: 5%;
        box-sizing: border-box;
        div {
          width: 100%;
          text-align: center;
          box-sizing: border-box;
        }
        .padding {
          padding: 30px 0;
          .mainTitle {
            font-size: 24px;
            color: #333;
          }
        }
        .content {
          height: 80px;
          color: #999;
        }
        .more {
          color: #999;
          font-size: 18px;
          padding: 24px 0;
          display: flex;
          justify-content:center;
          align-items: center;
          a {
            font-size: 18px;
            color: #999;
          }
          i {
            margin-left: 5px;
            font-size: 18px;
          }
        }
      }
      .item3 {
        width: 30%;
        height: 360px;
        margin-left: 5%;
        box-sizing: border-box;
        div {
          width: 100%;
          text-align: center;
          box-sizing: border-box;
        }
        .padding {
          padding: 30px 0;
          .mainTitle {
            font-size: 24px;
            color: #333;
          }
        }
        .content {
          height: 80px;
          color: #999;
        }
        .more {
          color: #999;
          font-size: 18px;
          padding: 24px 0;
          display: flex;
          justify-content:center;
          align-items: center;
          a {
            font-size: 18px;
            color: #999;
          }
          i {
            margin-left: 5px;
            font-size: 18px;
          }
        }
      }
    }
    .productBox {
      width: 100%;
      height: 570px;
      position: relative;
      box-sizing: border-box;
      background: url(../../static/images/productbox.png);
      .main {
        width: calc(100% - 160px);
        min-width: 1200px;
        height: 450px;
        position: absolute;
        left: 80px;
        top: 65px;
        z-index: 9;
        box-sizing: border-box;
        display: flex;
        justify-content:center;
        align-items: center;
        .left {
          width: 255px;
          height: 450px;
          box-sizing: border-box;
          .item {
            width: 100%;
            height: 90px;
            background-color: rgba(0, 0, 0, 0.5);
            cursor: pointer;
            .itemLeft {
              width: 80px;
              height: 90px;
              padding: 32px 12px 32px 42px;
              box-sizing: border-box;
              float: left;
              img {
                width: 26px;
                height: 26px;
              }
            }
            .itemRight {
              height: 90px;
              padding: 25px 12px 25px 5px;
              box-sizing: border-box;
              color: #fff;
              float: left;
              .pdes {
                padding-top: 3px;
                font-size: 10px;
              }
            }
          }
          .active {
            background-color: rgb(4, 187, 247);
          }
        }
        .right {
          width: calc(100% - 255px);
          height: 450px;
          padding-left: 100px;
          box-sizing: border-box;
          position: relative;
          .headTitle {
            font-size: 20px;
            color: #fff;
          }
          .subTitle {
            font-size: 16px;
            color: #fff;
            margin-top: 40px;
          }
          .subContent {
            height: 100px;
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-top: 16px;
          }
          .subMore {
            .btn {
              width: 100px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #fff;
              color: #fff;
              text-align: center;
              font-size: 12px;
              margin-top: 36px;
              cursor: pointer;
            }
          }
          .cusDemo {
            margin-top: 60px;
            .demoTitle {
              font-size: 20px;
              color: #fff;
            }
            .imgItem {
              margin-top: 20px;
              .imgBox {
                width: 180px;
                height: 60px;
                overflow: hidden;
                margin-right: 20px;
                display: inline-block;
                img {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
    .solution {
      width: 100%;
      min-width: 1360px;
      padding: 30px 80px 40px;
      text-align: center;
      box-sizing: border-box;
      background-color: rgb(250, 250, 250);
      .soluItemBox {
        width: 100%;
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;
        .soluItem1 {
          width: 50%;
          height: 300px;
          overflow: hidden;
          position: relative;
          .soluAlert1 {
            position: absolute;
            top: 25%;
            left: 50px;
            color: #333;
            text-align: left;
            .alertTitle {
              font-size: 18px;
            }
            .alertLine {
              width: 40px;
              height: 3px;
              margin: 3px 0;
              background-color: rgb(4, 187, 247);
            }
            .alertContent {
              margin-top: 16px;
              font-size: 14px;
            }
          }
          .soluAlert2 {
            position: absolute;
            top: 25%;
            left: 50px;
            color: #fff;
            text-align: left;
            .alertTitle {
              font-size: 18px;
            }
            .alertLine {
              width: 40px;
              height: 3px;
              margin: 3px 0;
              background-color: rgb(4, 187, 247);
            }
            .alertContent {
              margin-top: 16px;
              font-size: 14px;
            }
          }
          img {
            width: 100%;
          }
        }
        .soluItem2 {
          width: 33.3%;
          height: 300px;
          overflow: hidden;
          position: relative;
          .soluAlert1 {
            position: absolute;
            top: 65%;
            left: 50px;
            color: #333;
            text-align: left;
            .alertTitle {
              font-size: 18px;
            }
            .alertLine {
              width: 40px;
              height: 3px;
              margin: 3px 0;
              background-color: rgb(4, 187, 247);
            }
            .alertContent {
              margin-top: 16px;
              font-size: 14px;
            }
          }
          img {
            width: 100%;
          }
        }
        .soluItem3 {
          width: 33.4%;
          height: 300px;
          overflow: hidden;
          position: relative;
          .soluAlert1 {
            position: absolute;
            top: 65%;
            left: 50px;
            color: #fff;
            text-align: left;
            .alertTitle {
              font-size: 18px;
            }
            .alertLine {
              width: 40px;
              height: 3px;
              margin: 3px 0;
              background-color: rgb(4, 187, 247);
            }
            .alertContent {
              margin-top: 16px;
              font-size: 14px;
            }
          }
          img {
            width: 100%;
          }
        }
      }
    }
    .news {
      width: 100%;
      min-width: 1360px;
      padding: 30px 80px 40px;
      text-align: center;
      box-sizing: border-box;
      .newsItemBox {
        width: 100%;
        margin-top: 50px;
        display: flex;
        flex-wrap: wrap;
        .newsItem1 {
          width: 30%;
          height: 280px;
          overflow: hidden;
          box-sizing: border-box;
        }
        .newsItem2 {
          width: 30%;
          height: 280px;
          margin-left: 5%;
          overflow: hidden;
          box-sizing: border-box;
        }
        .newsImgTxtBox {
          width: 100%;
          height: 280px;
          border: 1px solid #ececec;
          box-sizing: border-box;
          .newsImgBox {
            width: 100%;
            height: 220px;
            overflow: hidden;
            img {
              width: 100%;
            }
          }
          .newsTxtBox {
            width: 100%;
            height: 60px;
            line-height: 60px;
            padding-left: 16px;
            box-sizing: border-box;
            text-align: left;
          }
        }
      }
    }
    .appBox {
      width: 100%;
      height: 246px;
      background: url(../assets/application.png);
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-size: 24px;
        font-weight: bolder;
        margin: 16px 0 30px;
      }
      .appBtnBox {
        width: 140px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        background-color: rgb(4, 187, 247);
        color: #fff;
        border-radius: 50px;
        cursor: pointer;
      }
    }
    .cwzfooter {
      width: 100%;
      height: 400px;
      padding: 60px 80px;
      box-sizing: border-box;
      background-color: rgb(33, 34, 50);
      display: flex;
      position: relative;
      .footItem1 {
        width: 350px;
        height: 250px;
        padding-right: 60px;
        img {
          max-width: 200px;
        }
        .website {
          padding: 16px 0;
          font-size: 20px;
          color: #fff;
        }
        .addr {
          margin-top: 30px;
          font-size: 14px;
          color: rgba(103, 107, 123, 1);
        }
      }
      .footItem2 {
        width: 150px;
        height: 250px;
        padding: 0 60px;
        .ksTitle {
          font-size: 14px;
          color: #fff;
        }
        .ksLink {
          font-size: 14px;
          margin-top: 30px;
          a {
            color: rgba(103, 107, 123, 1);
          }
        }
      }
      .footItem3 {
        width: 150px;
        height: 250px;
        padding: 0 60px;
        border-right: 1px solid #333743;
        .ksTitle {
          font-size: 14px;
          color: #fff;
        }
        .ksLink {
          font-size: 14px;
          margin-top: 30px;
          a {
            color: rgba(103, 107, 123, 1);
          }
        }
      }
      .footItem4 {
        height: 250px;
        padding: 0 60px;
        .ksTitle {
          font-size: 14px;
          color: #fff;
        }
        .ksLink {
          font-size: 14px;
          margin-top: 30px;
          span {
            color: rgba(103, 107, 123, 1);
          }
        }
      }
      .beian {
        width: 100%;
        height: 60px;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 0;
        div {
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: rgba(103, 107, 123, 1);
          font-size: 14px;
          a {
            color: rgba(103, 107, 123, 1);
          }
        }
      }
    }
  }

  .el-menu--horizontal>.el-menu-item {
    margin: 0 20px !important;
  }

  /deep/.swiper-pagination-bullet {
    width: 25px !important;
    height: 5px !important;
    border-radius: 0 !important;
    background-color: #fff !important;
  }

  /deep/.swiper-pagination-bullet-active {
    background-color: #ff6a00 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue